var render = function render(){var _vm=this,_c=_vm._self._c;return _c('md-card',{staticClass:"md-card-stats"},[_c('md-card-header',{attrs:{"data-background-color":_vm.dataBackgroundColor}},[_c('md-icon',[_vm._v(_vm._s(_vm.icon))])],1),_c('md-card-content',[_c('p',{staticClass:"category"},[_vm._v(_vm._s(_vm.title))]),_c('h5',{staticClass:"title"},[_vm._v(_vm._s(_vm.value))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }